import React, { useState } from 'react';
import { User, Bell, Lock, Download, Keyboard, Monitor, Camera } from 'lucide-react';
import { Button } from '../ui/Button';
export function UserPreferencesPage() {
  const [activeTab, setActiveTab] = useState('profile');
  const tabs = [{
    id: 'profile',
    label: 'Profile',
    icon: User
  }, {
    id: 'notifications',
    label: 'Notifications',
    icon: Bell
  }, {
    id: 'privacy',
    label: 'Privacy & Sharing',
    icon: Lock
  }, {
    id: 'export',
    label: 'Export',
    icon: Download
  }, {
    id: 'shortcuts',
    label: 'Shortcuts',
    icon: Keyboard
  }, {
    id: 'appearance',
    label: 'Appearance',
    icon: Monitor
  }];
  return <div className="flex h-screen bg-surface-900 text-text-primary">
      {/* Sidebar */}
      <div className="w-64 border-r border-surface-600 p-6">
        <h2 className="text-xl font-bold mb-8">Settings</h2>
        <div className="space-y-1">
          {tabs.map(tab => <button key={tab.id} onClick={() => setActiveTab(tab.id)} className={`w-full flex items-center gap-3 px-3 py-2 rounded-lg transition-colors ${activeTab === tab.id ? 'bg-primary-500/10 text-primary-400' : 'text-text-secondary hover:text-text-primary hover:bg-surface-800'}`}>
              <tab.icon className="w-4 h-4" />
              <span className="text-sm font-medium">{tab.label}</span>
            </button>)}
        </div>
      </div>

      {/* Content */}
      <div className="flex-1 overflow-y-auto p-12">
        <div className="max-w-2xl">
          <h1 className="text-2xl font-bold mb-8 capitalize">
            {activeTab.replace('-', ' ')}
          </h1>

          {activeTab === 'profile' && <div className="space-y-8">
              <div className="flex items-center gap-6">
                <div className="relative group cursor-pointer">
                  <div className="w-24 h-24 rounded-full bg-surface-800 flex items-center justify-center border-2 border-surface-500 overflow-hidden">
                    <span className="text-2xl font-bold text-text-muted">JD</span>
                  </div>
                  <div className="absolute inset-0 bg-black/50 rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                    <Camera className="w-6 h-6 text-text-primary" />
                  </div>
                </div>
                <div>
                  <h3 className="font-medium text-text-primary">Profile Picture</h3>
                  <p className="text-sm text-text-muted mt-1">
                    JPG, GIF or PNG. Max 1MB.
                  </p>
                  <Button variant="secondary" size="sm" className="mt-3">
                    Upload New
                  </Button>
                </div>
              </div>

              <div className="grid grid-cols-2 gap-6">
                <div>
                  <label className="block text-sm font-medium text-text-secondary mb-2">
                    First Name
                  </label>
                  <input type="text" defaultValue="John" className="w-full bg-surface-800 border border-surface-500 rounded-lg px-4 py-2 text-text-primary" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-text-secondary mb-2">
                    Last Name
                  </label>
                  <input type="text" defaultValue="Doe" className="w-full bg-surface-800 border border-surface-500 rounded-lg px-4 py-2 text-text-primary" />
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium text-text-secondary mb-2">
                  Email
                </label>
                <input type="email" defaultValue="john@acme.com" disabled className="w-full bg-surface-800/50 border border-surface-500 rounded-lg px-4 py-2 text-text-muted cursor-not-allowed" />
              </div>
            </div>}

          {activeTab === 'notifications' && <div className="space-y-6">
              <div className="bg-surface-800/50 rounded-xl border border-surface-600 overflow-hidden">
                <table className="w-full text-sm text-left">
                  <thead className="bg-surface-900 text-text-secondary uppercase text-xs">
                    <tr>
                      <th className="px-6 py-3">Event</th>
                      <th className="px-6 py-3 text-center">In-App</th>
                      <th className="px-6 py-3 text-center">Email</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-surface-600">
                    {['Task needs attention', 'Task completed', 'Stream shared with me', 'Knowledge request'].map(event => <tr key={event}>
                        <td className="px-6 py-4 text-text-primary">{event}</td>
                        <td className="px-6 py-4 text-center">
                          <input type="checkbox" defaultChecked className="rounded border-surface-500 bg-surface-900 text-primary-500" />
                        </td>
                        <td className="px-6 py-4 text-center">
                          <input type="checkbox" defaultChecked className="rounded border-surface-500 bg-surface-900 text-primary-500" />
                        </td>
                      </tr>)}
                  </tbody>
                </table>
              </div>
            </div>}

          <div className="mt-12 pt-8 border-t border-surface-600 flex justify-end gap-3">
            <Button variant="ghost">Cancel</Button>
            <Button className="bg-primary-600 hover:bg-blue-700 text-text-primary border-none">
              Save Changes
            </Button>
          </div>
        </div>
      </div>
    </div>;
}